module.exports = __webpack_public_path__ + "img/twitter-white.1d47e207.svg";